export default "__VITE_ASSET__BID2mp4a__"